var ro = {
  "Add Quantity Breaks to your product page": "Adăugați discounturi pentru cantitate pe pagina produsului",
  "Add Upsell.com to your ": "Adăugați Upsell.com la ",
  "Add to cart click": "Click pe Adaugă în coș",
  "All time": "Tot timpul",
  "and select": "și selectați",
  "button": "butonul",
  "Cart drawer page": "Pagina Sertarului coșului",
  "Cart page": "Pagina Coșului",
  "Check status": "Verifică starea",
  "Checkout page": "Pagina de Finalizare comandă",
  "Checkout click": "Click pe Finalizare comandă",
  "Click": "Faceți clic pe",
  "Click on": "Faceți clic pe",
  "Click the": "Faceți clic pe",
  "Custom slot": "Slot personalizat",
  "Custom slots": "Sloturi personalizate",
  "Custom Slots": "Sloturi personalizate",
  "Enable in theme editor": "Activează în editorul de temă",
  "contact support.": "contactați suportul.",
  "from the right sidebar": "din bara laterală dreaptă",
  "Go to App Embeds": "Mergeți la încorporări de aplicații",
  "Go to your Cart drawer page": "Mergeți la pagina Sertarului coșului",
  "Go to your Cart page": "Mergeți la pagina Coșului",
  "Go to your Checkout page": "Mergeți la pagina de Finalizare comandă",
  "Go to your Order status page": "Mergeți la pagina de Stare a comenzii",
  "Go to your Post purchase page": "Mergeți la pagina Post-cumpărare",
  "Go to your Product page": "Mergeți la pagina Produsului",
  "Go to your Thank you page": "Mergeți la pagina de Mulțumire",
  "items": "articole",
  "in the left sidebar": "în bara laterală stângă",
  "Last 12 months": "Ultimele 12 luni",
  "Last 30 days": "Ultimele 30 de zile",
  "Last 365 days": "Ultimele 365 de zile",
  "Last 7 days": "Ultimele 7 zile",
  "Last 90 days": "Ultimele 90 de zile",
  "Last month": "Luna trecută",
  "Last year": "Anul trecut",
  "Make sure": "Asigurați-vă că",
  "Need assistance? Contact our support team for help.": "Aveți nevoie de asistență? Contactați echipa noastră de suport.",
  "Order status page": "Pagina de Stare a comenzii",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "Aplicația noastră trece printr-un proces de îmbunătățire pentru a vă oferi o experiență mai bună.",
  "Post purchase page": "Pagina Post-cumpărare",
  "Product page": "Pagina Produsului",
  "Save": "Salvare",
  "Scroll to the bottom and select": "Derulați până jos și selectați",
  "Select": "Selectați",
  "Success. Please continue.": "Succes. Vă rugăm să continuați.",
  "Thank you page": "Pagina de Mulțumire",
  "The Upsell.com team.": "Echipa Upsell.com.",
  "The Upsell.com widget is not placed on ": "Widget-ul Upsell.com nu este plasat pe ",
  ". Please follow the steps above or ": ". Vă rugăm să urmați pașii de mai sus sau ",
  "Today": "Astăzi",
  "toggle is on": "comutatorul este activat",
  "Total": "Total",
  "under": "sub",
  "We apologize for any inconvenience caused,": "Ne cerem scuze pentru orice neplăcere cauzată,",
  "We apologize for any inconvenience caused.": "Ne cerem scuze pentru orice neplăcere cauzată.",
  "We'll be done in a few minutes!": "Vom termina în câteva minute!",
  "We're improving our services!": "Ne îmbunătățim serviciile!",
  "Widget already added": "Widget deja adăugat",
  "Yesterday": "Ieri",
  "You enabled the widget in your online store but didn't save it in the Upsell editor": "Ați activat widgetul în magazinul online, dar nu l-ați salvat în editorul Upsell",
  "You placed the widget on the ": "Ați plasat widget-ul pe ",
  ", but you didn't save it in Shopify editor. Please go back to ": ", dar nu l-ați salvat în editorul Shopify. Vă rugăm să reveniți la ",
  " and save the changes.": " și să salvați modificările."
};

export { ro as default };
//# sourceMappingURL=ro.json.js.map
